import { render, staticRenderFns } from "./PlatformBankAccounts.vue?vue&type=template&id=5de67cb1&"
import script from "./PlatformBankAccounts.vue?vue&type=script&lang=js&"
export * from "./PlatformBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports